module.exports = __webpack_public_path__ + "img/square.6f7fb833.png";